export function isWeixin () {
    var ua = window.navigator.userAgent.toLowerCase();
    if(ua.match(/MicroMessenger/i) || ua.match(/_SQ_/i)){
        return true;
    } else{
        return false;
    }
  }
  